import { apiRequest } from "@gogive/services";
import { chatRoutes } from "./chat.route";
import type { ChatConversationSummary } from "./chat.types";

export async function renameConversation(
  conversationId: string,
  title: string,
): Promise<ChatConversationSummary> {
  return apiRequest<ChatConversationSummary>(chatRoutes.update(conversationId), {
    method: "PATCH",
    data: { title },
  });
}

export async function archiveConversation(conversationId: string): Promise<void> {
  await apiRequest<{ ok: boolean }>(chatRoutes.archive(conversationId), {
    method: "POST",
    data: {},
  });
}
